// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"914b65d6","643":"cea52300","821":"8a445391"}[chunkId] + ".chunk.css";
};